import { formatBaht } from '@xver/utils/number';
import { IconCurrencyBaht } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { Button } from '@xver/components/Atoms';
import DialogBox from '@xver/components/Atoms/DialogBox/DialogBox';

interface CreditCardProps {
    credit: number;
}

export default function CreditCard({ credit }: CreditCardProps) {
    const { t } = useTranslation('billings');
    const navigate = useNavigate();
    return (
        <DialogBox label={t('credit.title')} classNames="p-4">
            <div className="w-full flex flex-row justify-between items-center gap-4">
                <div className="inline-flex items-center ">
                    <span className="text-3xl font-bold">{formatBaht(credit)}</span>
                    <IconCurrencyBaht size={30} stroke={2.5} />
                </div>
                <Button onClick={() => navigate('/platform/topup')}>{t('credit.topUp')}</Button>
            </div>
        </DialogBox>
    );
}
